import { createContext } from 'react';

export const CONSENT_KEY = 'cookieConsent';

export type ConsentStatus = 'pending' | 'accepted' | 'rejected';

export interface CookieConsentContextValue {
  consentStatus: ConsentStatus;
  hasAnalyticsConsent: boolean;
  acceptAnalytics: () => void;
  rejectAnalytics: () => void;
  setAnalyticsConsent: (value: boolean) => void;
}

export const CookieConsentContext = createContext<CookieConsentContextValue | null>(null);

export function readStoredConsent(): ConsentStatus {
  if (typeof window === 'undefined') return 'pending';
  try {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (stored === 'accepted') return 'accepted';
    if (stored === 'rejected') return 'rejected';
  } catch {
    // ignore
  }
  return 'pending';
}
